import { useState } from "react";
import ReactDOM from "react-dom";
import IconButton from "@weave-design/icon-button";
import { SurveyEquipment24 } from "@weave-design/icons";
import { ProcessingFailure } from "../../../../processing-failure/processingFailure";
import { ProcessingPane } from "../../../../processing-pane/processingPane";
import { rootElement } from "../../../../shared";
import { LinkedModelOriginEditorDialog } from "./linkedModelOriginEditorDialog";
import eventBus from "../../../eventBus/eventDispatcher";
import repo from "../../../../../Repository";

type Props = {
    id: string;
    origin: THREE.Vector3;
};

export const LinkedModelOriginEditor = ({ id, origin }: Props) => {
    const [originEditorDialogOpened, setOriginEditorDialogOpened] = useState(false);
    const [inProgress, setInProgress] = useState(false);
    const [failure, setFailure] = useState("");

    const openOriginEditorDialog = (e: React.SyntheticEvent) => {
        e.stopPropagation();
        setOriginEditorDialogOpened(true);
    };

    const onClose = () => {
        setOriginEditorDialogOpened(false);
    };

    const updateLinkedModelOrigin = async (newOrigin: THREE.Vector3) => {
        setOriginEditorDialogOpened(false);
        setInProgress(true);

        const response = await repo.updateLinkedModelOrigin(id, newOrigin);

        setInProgress(false);

        if (response.isSuccess) {
            eventBus.dispatchEvent({
                type: "Dextall.LinkedModels.UI.UpdateOrigin",
                payload: { id, origin: newOrigin },
            });
        } else {
            setFailure(response.message);
        }
    };

    return (
        <>
            <IconButton
                icon={
                    <div style={{ width: 24, height: 24 }}>
                        <SurveyEquipment24 />
                    </div>
                }
                title="Edit linked model origin"
                onClick={openOriginEditorDialog}
            />

            {originEditorDialogOpened &&
                ReactDOM.createPortal(
                    <LinkedModelOriginEditorDialog
                        origin={origin}
                        updateLinkedModelOrigin={updateLinkedModelOrigin}
                        close={onClose}
                    />,
                    rootElement,
                )}

            {inProgress &&
                ReactDOM.createPortal(
                    <ProcessingPane isVisible message="Updating linked model offset..." title="Linked model" />,
                    rootElement,
                )}

            {failure &&
                ReactDOM.createPortal(
                    <ProcessingFailure
                        isVisible
                        title="Linked model"
                        message={failure}
                        closeProcessingErrorDialog={() => setFailure("")}
                    />,
                    rootElement,
                )}
        </>
    );
};
